
export const DG_Format_Money = (money)=>{
    if (money)
        return new Intl.NumberFormat('vi-VN').format(money.toFixed(1))

    return money
}
